import React from "react";

interface ContactCardProps {
  icon: string;
  title: string;
  children: React.ReactNode;
}

export function ContactCard({ icon, title, children }: ContactCardProps) {
  return (
    <div className="bg-white/5 backdrop-blur-md border border-white/10 p-6 sm:p-10 rounded-2xl flex flex-col justify-center">
      <div className="w-12 h-12 bg-dourado/20 rounded-full flex items-center justify-center text-dourado mb-6 text-xl">
        <i className={`fa-solid ${icon}`}></i>
      </div>
      <h3 className="font-titulo text-2xl font-bold mb-4">{title}</h3>
      {children}
    </div>
  );
}
export default ContactCard;
